// THE MISSING DROP — client. No decisive logic here: every check is an RPC (see supabase/001_missing_drop.sql).
// The browser never holds the solution, the hotspots or the sign values (until the server reveals them).
// Transport: direct calls to the missing-drop-validator edge function, authenticated by an HMAC-signed Shopify customer id.
const root = document.querySelector('[data-md]');
if (root) init();

function init() {
  const $ = (s, r = root) => r.querySelector(s), $$ = (s, r = root) => [...r.querySelectorAll(s)];
  const cfg = JSON.parse($('[data-md-cfg]').textContent);
  const A = JSON.parse($('[data-md-assets]').textContent);
  const mq = matchMedia('(max-width: 749px)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SIGNS = ['key', 'witch_hat', 'skull', 'hangtag', 'pumpkin'];
  const CARD = { witch_hat: 'md-card-witch', skull: 'md-card-skull', key: 'md-card-key', pumpkin: 'md-card-pumpkin', hangtag: 'md-card-hangtag' };

  // Copy supplied by the brand (EN/IT). Static trusted strings: <b> allowed, \n = line break. {eur} is filled with a number.
  const T = {
    en: {
      introText: 'The drop is missing.\nSomeone left five signs behind.\n\nFind them. Work out the combination.\nCrack the safe.', introCta: 'OPEN THE CASE',
      prizesTitle: 'THE CASE IS OPEN. THREE SPOTS AVAILABLE.',
      prizesText: 'The first three to crack the safe win one of three gift cards: <b>€200, €100 and €50</b>.\n\nOnce all three prizes have been awarded, anyone who completes the game can claim free shipping. No minimum spend.\n\nYour code arrives by email and is valid for 24 hours from the time it’s sent.',
      rulesTitle: 'THE CLUES ARE RIGHT IN FRONT OF YOU.',
      rulesText: 'Scroll through the photos and find the five signs shown below.\nTap each sign you spot to uncover its clue.\n\nThen piece it all together and try the combination.', rulesCta: 'START LOOKING',
      open1: 'Open photo 1', open2: 'Open photo 2', open3: 'Open photo 3', open4: 'Open photo 4',
      safeTitle: 'GOT A THEORY? TRY IT.', safeText: 'Enter the combination.\nYou can take a guess before finding all five signs.', safeCta: 'CRACK THE SAFE',
      codeLabel: 'Five-digit combination', zoom: 'Zoom', close: 'Close',
      vAria: 'Photo. Use the arrow keys to move the pointer and Enter to check that spot.',
      sign_witch_hat: 'Witch’s hat', sign_skull: 'Skull', sign_key: 'Kids Make Noise key', sign_pumpkin: 'Pumpkin', sign_hangtag: 'Halloween hangtag',
      found: 'You found: {s}', already: 'Already found: {s}', nothing: 'Nothing here. Keep looking.',
      errInvalid: 'Enter exactly five digits.', errWrong: 'That’s not the combination. Try again.', errRate: 'Too many tries. Wait a moment.',
      errNotOpen: 'The safe is not open yet.', errClosed: 'The game is closed.', errNet: 'Connection problem. Please retry.',
      topTitle: 'CASE CLOSED. NICE WORK.', topText: 'You’re one of the first three.\nYou’ve won a <b>€{eur} gift card</b>.\n\nThe drop is still missing.\nAt least you got something out of it.',
      shipTitle: 'CASE CLOSED. SHIPPING’S ON US.', shipText: 'You cracked the safe.\nWe’ll cover your next delivery.\n\nNo minimum spend.\nYour code will arrive by email and will be valid for 24 hours from the time it’s sent.',
      extraTitle: 'WAIT. THERE’S SOMETHING ELSE.', extraCta: 'TAKE A LOOK',
      // not in the supplied copy (placeholders to approve):
      lockedTitle: 'CASE CLOSED.', shipLocked: 'You cracked the safe. Your free-shipping card unlocks as soon as the three main prizes are assigned.',
      shipClaim: 'Claim free shipping', shipPending: 'We’re sending your code by email.', shipSent: 'Sent! Valid 24 hours from sending. Check your inbox.', shipError: 'Delivery problem — we’re retrying automatically.',
    },
    it: {
      introText: 'Il drop è sparito.\nQualcuno ha lasciato cinque segni.\n\nTrovali. Ricostruisci la combinazione.\nApri la cassaforte.', introCta: 'APRI IL CASO',
      prizesTitle: 'IL CASO È APERTO. I POSTI SONO TRE.',
      prizesText: 'I primi tre che aprono la cassaforte vincono una delle tre gift card: <b>200€, 100€ e 50€</b>.\n\nDopo l’assegnazione dei tre premi, chi completa il gioco può ottenere la spedizione gratuita senza minimo d’ordine.\n\nIl codice arriva via email ed è valido per 24 ore dall’invio.',
      rulesTitle: 'GLI INDIZI SONO SOTTO I TUOI OCCHI.',
      rulesText: 'Scorri le foto e trova i cinque segni mostrati qui sotto.\nTocca ogni segno che riconosci per scoprire il suo indizio.\n\nPoi metti insieme quello che hai trovato e prova la combinazione.', rulesCta: 'INIZIA A CERCARE',
      open1: 'Apri foto 1', open2: 'Apri foto 2', open3: 'Apri foto 3', open4: 'Apri foto 4',
      safeTitle: 'HAI UNA TEORIA? PROVALA.', safeText: 'Inserisci la combinazione.\nPuoi provarci anche senza aver trovato tutti i segni.', safeCta: 'APRI LA CASSAFORTE',
      codeLabel: 'Combinazione di cinque cifre', zoom: 'Zoom', close: 'Chiudi',
      vAria: 'Foto. Usa le frecce per muovere il puntatore e Invio per controllare quel punto.',
      sign_witch_hat: 'Cappello da strega', sign_skull: 'Teschio', sign_key: 'Chiave Kids Make Noise', sign_pumpkin: 'Zucca', sign_hangtag: 'Cartellino Halloween',
      found: 'Hai trovato: {s}', already: 'Già trovato: {s}', nothing: 'Qui non c’è niente. Continua a cercare.',
      errInvalid: 'Inserisci esattamente cinque cifre.', errWrong: 'Non è la combinazione giusta. Riprova.', errRate: 'Troppi tentativi. Attendi un attimo.',
      errNotOpen: 'La cassaforte non è ancora aperta.', errClosed: 'Il gioco è chiuso.', errNet: 'Problema di connessione. Riprova.',
      topTitle: 'CASO CHIUSO. BEL COLPO.', topText: 'Sei tra i primi tre.\nHai vinto una gift card da <b>{eur}€</b>.\n\nIl drop è ancora disperso.\nTu, intanto, ci hai guadagnato.',
      shipTitle: 'CASO CHIUSO. SPEDIZIONE OFFERTA.', shipText: 'Hai aperto la cassaforte.\nLa prossima spedizione la paghiamo noi.\n\nNessun minimo d’ordine.\nRiceverai il codice via email: sarà valido per 24 ore dall’invio.',
      extraTitle: 'ASPETTA. È RIMASTO QUALCOSA.', extraCta: 'DAI UN’OCCHIATA',
      // non presenti nel copy fornito (segnaposto da approvare):
      lockedTitle: 'CASO CHIUSO.', shipLocked: 'Hai aperto la cassaforte. La tua card spedizione gratuita si sblocca appena vengono assegnati i tre premi principali.',
      shipClaim: 'Richiedi la spedizione gratuita', shipPending: 'Stiamo inviando il codice via email.', shipSent: 'Inviato! Valido 24 ore dall’invio. Controlla la posta.', shipError: 'Problema di consegna: stiamo riprovando in automatico.',
    },
  };
  const ERR = { invalid: 'errInvalid', wrong: 'errWrong', rate_limited: 'errRate', not_open: 'errNotOpen', closed: 'errClosed' };

  const pickLocale = () => {
    try { const s = localStorage.getItem('md_lang'); if (s === 'it' || s === 'en') return s; } catch (_) {}
    return (navigator.language || '').toLowerCase().startsWith('it') ? 'it' : 'en';   // explicit choice wins, else IT for Italian browsers
  };
  const S = { locale: pickLocale(), mobile: mq.matches, st: null, scene: null, tok: 0 };
  const tr = (k) => T[S.locale][k] ?? '';
  const sx = () => (S.mobile ? 'mobile' : 'web');

  // asset resolver: base-variant-locale → base-variant → base-locale → base (localized art can be dropped in later)
  const url = (b) => A[`${b}-${sx()}-${S.locale}`] || A[`${b}-${sx()}`] || A[`${b}-${S.locale}`] || A[b] || '';

  // Atomic swap: preload + decode everything for the new locale/variant, then switch all srcs in one frame.
  // The stage keeps its CSS aspect-ratio throughout, so the scroll position never jumps.
  async function applyAssets() {
    const tok = ++S.tok;
    const jobs = $$('[data-md-img]').filter((el) => !el.closest('[hidden]'))
      .map((el) => ({ el, u: url(el.dataset.mdImg) })).filter((j) => j.u && j.el.getAttribute('src') !== j.u);
    await Promise.all(jobs.map(({ u }) => { const i = new Image(); i.src = u; return i.decode().catch(() => {}); }));
    if (tok !== S.tok) return;                       // a newer request superseded this one
    requestAnimationFrame(() => jobs.forEach(({ el, u }) => el.setAttribute('src', u)));
  }

  function applyText() {
    $$('[data-md-t]').forEach((e) => { e.innerHTML = tr(e.dataset.mdT); });   // static trusted strings only
    $$('[data-md-t-aria]').forEach((e) => e.setAttribute('aria-label', tr(e.dataset.mdTAria)));
    $$('[data-md-lang]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mdLang === S.locale)));
    render();
  }

  // ───────── rendering ─────────
  function renderLegend() {
    const found = new Set(S.st?.found || []), vals = S.st?.values || {};
    $('[data-md-legend]').replaceChildren(...SIGNS.map((id) => {
      const d = document.createElement('div'); d.className = 'md__sign';
      if (found.has(id)) d.dataset.found = '';
      const im = new Image(); im.src = url(CARD[id]); im.alt = tr('sign_' + id) + (found.has(id) ? ' ✓' : '');
      d.append(im);
      if (vals[id]) { const b = document.createElement('b'); b.textContent = vals[id]; d.append(b); }
      return d;
    }));
  }

  function renderResult() {
    const st = S.st, done = st?.status === 'completed', box = $('#md-result');
    $('[data-md-code]').hidden = done;
    $('.md__safe-copy').hidden = done;
    $('[data-md-img^="md-safe-"]').dataset.mdImg = done ? 'md-safe-open' : 'md-safe-insert';
    box.hidden = !done;
    if (!done) return;
    const eur = Number(st.reward_eur), top = !!eur && st.rank <= 3;
    box.classList.toggle('is-top', top);
    const sh = st.shipping || { state: 'locked' };
    $('[data-md-result-bg]').dataset.mdImg = top ? `md-card-${eur}` : 'md-card-universal';
    const gift = $('[data-md-result-gift]'); gift.hidden = !top; if (top) gift.dataset.mdImg = `md-giftcard-${eur}`;
    $('[data-md-result-title]').innerHTML = top ? tr('topTitle') : tr(sh.state === 'locked' ? 'lockedTitle' : 'shipTitle');
    $('[data-md-result-text]').innerHTML = top ? tr('topText').replace('{eur}', eur) : tr(sh.state === 'locked' ? 'shipLocked' : 'shipText');
    // const btn = $('[data-md-ship]'), msg = $('[data-md-ship-msg]');
    // btn.hidden = top || sh.state !== 'available'; btn.textContent = tr('shipClaim');
    // msg.textContent = top || sh.state !== 'claimed' ? '' : tr({ sent: 'shipSent', error: 'shipError' }[sh.send_status] || 'shipPending');
  }

  function render() { renderLegend(); renderResult(); applyAssets(); }

  // ───────── backend (missing-drop-validator edge function) ─────────
  // The validator trusts only the HMAC-signed customer id minted by Liquid, never x-customer-id.
  const headers = () => ({
    'Content-Type': 'application/json', apikey: cfg.key, Authorization: `Bearer ${cfg.key}`,
    'x-md-cid': String(cfg.customer), 'x-md-ts': cfg.ts, 'x-md-sig': cfg.sig,
    'x-md-email': encodeURIComponent(cfg.email || ''), 'x-md-esig': cfg.esig || '',
  });
  async function rpc(path, args = {}) {
    const r = await fetch(`${cfg.url}/functions/v1/missing-drop-validator/${path}`, { method: 'POST', headers: headers(), body: JSON.stringify(args) });
    const j = await r.json().catch(() => ({}));
    if (r.ok && j.code === 'OP_200') return j.data;
    if (j.code === 'OP_401' && !sessionStorage.getItem('md_reloaded')) { sessionStorage.setItem('md_reloaded', '1'); location.reload(); }   // expired signature → fresh page = fresh signature
    throw new Error(j.code || String(r.status));
  }
  const loadState = async () => { S.st = await rpc('md-state', { p_campaign: cfg.campaign, p_locale: S.locale }); sessionStorage.removeItem('md_reloaded'); render(); };

  // ───────── language / variant ─────────
  $$('[data-md-lang]').forEach((b) => b.addEventListener('click', () => {
    S.locale = b.dataset.mdLang;
    try { localStorage.setItem('md_lang', S.locale); } catch (_) {}
    applyText();                                      // account, found signs, attempts and prizes live server-side: nothing is lost
    if (S.st) rpc('md-state', { p_campaign: cfg.campaign, p_locale: S.locale }).catch(() => {});
  }));
  mq.addEventListener('change', (e) => { S.mobile = e.matches; applyAssets(); });  // resize / rotation

  // ───────── flow ─────────
  const scrollTo = (sel) => $(sel).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  const gated = (fn) => { if (cfg.customer) fn(); else location.href = cfg.login; };   // Shopify account login, then back to this page
  $$('[data-md-play]').forEach((b) => b.addEventListener('click', () => gated(() => scrollTo('#md-rules'))));
  $('[data-md-rules-cta]').addEventListener('click', () => gated(() => scrollTo('#md-scene1')));
  $$('[data-md-open]').forEach((b) => b.addEventListener('click', () => gated(() => openViewer(+b.dataset.mdOpen))));

  // ───────── photo viewer + discovery ─────────
  const vd = $('[data-md-viewer]'), vimg = $('[data-md-vimg]'), vwrap = $('[data-md-vwrap]'), ping = $('[data-md-ping]'),
        cross = $('[data-md-cross]'), vmsg = $('[data-md-vmsg]'), vs = $('[data-md-vscroll]');
  const cur = { x: 0.5, y: 0.5 }; let busy = false;
  const clamp = (v) => Math.min(1, Math.max(0, v));

  function openViewer(n) {
    S.scene = 'scene' + n; vimg.src = url('md-photo' + n);
    vwrap.classList.remove('is-zoom'); vmsg.textContent = ''; cross.hidden = true; vd.showModal(); vs.focus();
  }
  $('[data-md-vclose]').addEventListener('click', () => vd.close());
  $('[data-md-zoom]').addEventListener('click', () => vwrap.classList.toggle('is-zoom'));

  const place = (el, x, y) => { el.style.left = x * 100 + '%'; el.style.top = y * 100 + '%'; };
  async function probe(x, y) {
    if (busy) return; busy = true;
    ping.hidden = true; void ping.offsetWidth; place(ping, x, y); ping.classList.remove('is-hit'); ping.hidden = false;
    try {
      const r = await rpc('md-discover', {
        p_campaign: cfg.campaign, p_scene: S.scene, p_variant: `${S.mobile ? 'mobile' : 'desktop'}-${S.locale}`,
        p_x: +x.toFixed(4), p_y: +y.toFixed(4),
      });
      if (r.hit) {
        const was = new Set(S.st?.found || []).has(r.sign_id), name = tr('sign_' + r.sign_id);
        S.st = r.state; renderLegend(); ping.classList.add('is-hit');
        vmsg.textContent = tr(was ? 'already' : 'found').replace('{s}', name);
      } else vmsg.textContent = tr(r.error === 'rate_limited' ? 'errRate' : 'nothing');   // a miss never penalizes
    } catch (_) { vmsg.textContent = tr('errNet'); } finally { busy = false; }
  }
  // normalized coords are taken from the rendered image box, so zoom/resize/rotation never skew them
  vimg.addEventListener('click', (e) => { const r = vimg.getBoundingClientRect(); probe(clamp((e.clientX - r.left) / r.width), clamp((e.clientY - r.top) / r.height)); });
  // keyboard: same search, no hints — arrows move a pointer, Enter checks the spot
  vs.addEventListener('keydown', (e) => {
    const st = e.shiftKey ? 0.005 : 0.02;
    const m = { ArrowLeft: [-st, 0], ArrowRight: [st, 0], ArrowUp: [0, -st], ArrowDown: [0, st] }[e.key];
    if (m) { e.preventDefault(); cur.x = clamp(cur.x + m[0]); cur.y = clamp(cur.y + m[1]); place(cross, cur.x, cur.y); cross.hidden = false; vmsg.textContent = `${Math.round(cur.x * 100)}%, ${Math.round(cur.y * 100)}%`; }
    else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); probe(cur.x, cur.y); }
  });

  // ───────── safe ─────────
  const codeForm = $('[data-md-code]'), cmsg = $('[data-md-msg]');
  codeForm.addEventListener('submit', (e) => {
    e.preventDefault();
    gated(async () => {
      try {
        const r = await rpc('md-submit-code', { p_campaign: cfg.campaign, p_code: codeForm.code.value });
        if (!r.ok) { cmsg.textContent = tr(ERR[r.error] || 'errWrong'); return; }
        cmsg.textContent = ''; S.st = r.state; render();
        root.dispatchEvent(new CustomEvent('md:solved', { detail: r.state }));   // hook for the extras / collab reveal
        requestAnimationFrame(() => scrollTo('#md-result'));
      } catch (_) { cmsg.textContent = tr('errNet'); }
    });
  });
  // $('[data-md-ship]').addEventListener('click', async () => {
  //   try { S.st = await rpc('md-claim-shipping', { p_campaign: cfg.campaign }); render(); } catch (_) { $('[data-md-ship-msg]').textContent = tr('errNet'); }
  // });
  // lightweight refresh: unlocks the shipping card for people already on the page when the 3rd prize is assigned
  setInterval(() => { if (!document.hidden && S.st?.status === 'completed' && S.st.shipping?.state === 'locked') loadState().catch(() => {}); }, 30000);

  // ───────── boot ─────────
  applyText();                                        // paint first, connect after
  if (cfg.customer) loadState().catch(() => {});
}
